import { Field } from '@nestjs/graphql'
import { ArgsType } from '@nestjs/graphql'

@ArgsType()
export class NotificationUnsubArgs {
  @Field()
  unsubId?: string

  @Field()
  key!: string
}
